import { createTRPCClient, httpBatchLink, httpLink, splitLink } from '@trpc/client';

// NOTE: backend側で生成したtRPC型定義を使用する
import type { AppRouter } from '../../trpc-types';
import { getClientId } from './app/domain';
import type { inferRouterOutputs } from '@trpc/server';
import { FirebaseAuthenticationClient } from './firebase/auth';

const url =
  process.env.NODE_ENV === 'test'
    ? 'http://localhost:9082/trpc' // テスト環境ではホスト含めて指定する
    : '/trpc';

async function createHeaders() {
  const token = await FirebaseAuthenticationClient.getIdToken();
  return {
    'X-Application-Name': 'balus-webapp',
    'X-Client-Id': getClientId(),
    ...(typeof token === 'string' ? { 'X-Balus-ID-Token': token } : {}),
  };
}

export const trpcClient = createTRPCClient<AppRouter>({
  links: [
    splitLink({
      // ファイルアップロードで使うFormDataを使うリクエストはバッチ処理できないので分岐させる
      condition: (op) => op.input instanceof FormData,
      true: httpLink({
        url,
        headers: createHeaders,
      }),
      false: httpBatchLink({
        url,
        headers: createHeaders,
      }),
    }),
  ],
});

export type AppRouterOutputs = inferRouterOutputs<AppRouter>;
